export default "__VITE_ASSET__05c37f0d__"